import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../typography/Text.js';
import '../typography/Display.js';
import '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import React__default from 'react';
import '../../node_modules/lodash/_Stack.js';
import '../../node_modules/lodash/_SetCache.js';
import '../../node_modules/lodash/_equalByTag.js';
import '../../node_modules/lodash/isArguments.js';
import '../../node_modules/lodash/isBuffer.js';
import '../../node_modules/lodash/isTypedArray.js';
import '../../node_modules/lodash/_baseGetTag.js';
import '../../node_modules/lodash/_getTag.js';
import '../provider/WindowSizeContext.js';
import '../provider/ColorModeContext.js';
import { useClipboard } from '../../hooks/useClipboard.js';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { hoverColor } from '../../utils/hoverColor.js';
import { InputRightElement } from './InputElement.js';
import { InputGroup } from './InputGroup.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
var InputWrapper = styled(Box)(variant({
  prop: "size",
  variants: {
    md: {
      height: "56px"
    },
    lg: {
      height: "72px"
    }
  }
}), function (_a) {
  var backgroundColor = _a.backgroundColor;
  return css({
    display: "flex",
    alignItems: "center",
    paddingX: "16px",
    width: "100%",
    transition: "all 250ms",
    border: "base",
    borderColor: "grey.5",
    "[role=group]:hover &, :hover": {
      backgroundColor: hoverColor(backgroundColor)
    }
  });
});
var Label = styled(Paragraph)(css({
  userSelect: "none",
  color: "grey.1",
  marginBottom: "4px"
}));
var Text = styled(Paragraph)(css({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  maxWidth: "calc(100% - 76px)"
}));
var CopyIcon = styled(Icon)(function (_a) {
  var hasCopied = _a.hasCopied;
  return css({
    color: hasCopied ? "green.300" : "textPrimary",
    fontSize: "22px",
    transition: "all 200ms",
    cursor: "pointer",
    ":hover": {
      color: hasCopied ? "green.300" : "grey.1"
    }
  });
});
var CopyInput = function CopyInput(_a) {
  var _b = _a.size,
    size = _b === void 0 ? "md" : _b,
    label = _a.label,
    value = _a.value,
    rest = __rest(_a, ["size", "label", "value"]);
  var _c = useClipboard(value),
    onCopy = _c.onCopy,
    hasCopied = _c.hasCopied;
  return React__default.createElement(InputGroup, {
    role: "group"
  }, React__default.createElement(InputWrapper, __assign({
    as: "label",
    size: size
  }, rest), React__default.createElement(Box, {
    width: "100%"
  }, typeof label === "string" ? React__default.createElement(Label, {
    size: "xs"
  }, label) : label, React__default.createElement(Text, {
    size: "md",
    weight: "heavy"
  }, value))), React__default.createElement(InputRightElement, null, React__default.createElement(CopyIcon, {
    icon: hasCopied ? "done" : "copy",
    onClick: onCopy,
    hasCopied: hasCopied
  })));
};
export { CopyInput };